// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  contextPath: "/factures/",
  templateBaseUrl: "/template-serveur/templates/",
  i18nBaseUrl: "/template-serveur/i18n/factures/",
  i18nHFBaseUrl: "/template-serveur/i18n/header-footer/"
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/environments/environment.ts